// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-register-container>*{cursor:pointer}.v-overlay--active{-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px);background:rgba(0,0,0,.5)}.login-dialog{box-shadow:none}@media (min-height:720px){.login-dialog{position:relative;top:-84px}}@media (min-width:600px){.login-dialog{top:-104px}}.register-btn{border-color:#fff!important}.register-dialog-container{margin-top:20vh}", ""]);
// Exports
module.exports = exports;
